import { render, staticRenderFns } from "./ComprasControl.vue?vue&type=template&id=0b8e3050&scoped=true"
import script from "./ComprasControl.vue?vue&type=script&lang=js"
export * from "./ComprasControl.vue?vue&type=script&lang=js"
import style0 from "./ComprasControl.vue?vue&type=style&index=0&id=0b8e3050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e3050",
  null
  
)

export default component.exports